import { FORM_INPUTS } from "./formInputs";
import { SUID } from "./suid";

export const generateUserRequestData = () => {
    const firstName = FORM_INPUTS.firstName.element;
    const lastName = FORM_INPUTS.lastName.element;
    const phoneNumber = FORM_INPUTS.phoneNumber.element;
    const address = FORM_INPUTS.address.element;
    const city = FORM_INPUTS.city.element;
    const zipCode = FORM_INPUTS.zipCode.element;
    const state = FORM_INPUTS.state.element;

    return {
        "suid": SUID.value,
        "firstName": firstName ? firstName.value : null,
        "lastName": lastName ? lastName.value : null,
        "email": FORM_INPUTS.email.element.value,
        "phoneNumber": phoneNumber ? phoneNumber.value : null,
        "address": address ? address.value : null,
        "city": city ? city.value : null,
        "zipCode": zipCode ? zipCode.value : null,
        "state": state ? state.value : null,
    }
}